{
	"textures": [
		{
			"image": "loading_gif.png",
			"format": "RGBA8888",
			"size": {
				"w": 884,
				"h": 2695
			},
			"scale": 1,
			"frames": [
				{
					"filename": "loading03",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 478,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 478,
						"h": 383
					}
				},
				{
					"filename": "loading07",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 478,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 386,
						"w": 478,
						"h": 383
					}
				},
				{
					"filename": "loading11",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 478,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 771,
						"w": 478,
						"h": 383
					}
				},
				{
					"filename": "loading15",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 478,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 1156,
						"w": 478,
						"h": 383
					}
				},
				{
					"filename": "loading02",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 453,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 1541,
						"w": 453,
						"h": 383
					}
				},
				{
					"filename": "loading06",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 453,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 1926,
						"w": 453,
						"h": 383
					}
				},
				{
					"filename": "loading10",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 453,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 1926,
						"w": 453,
						"h": 383
					}
				},
				{
					"filename": "loading14",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 453,
						"h": 383
					},
					"frame": {
						"x": 1,
						"y": 2311,
						"w": 453,
						"h": 383
					}
				},
				{
					"filename": "loading01",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 427,
						"h": 383
					},
					"frame": {
						"x": 456,
						"y": 1541,
						"w": 427,
						"h": 383
					}
				},
				{
					"filename": "loading13",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 427,
						"h": 383
					},
					"frame": {
						"x": 456,
						"y": 1541,
						"w": 427,
						"h": 383
					}
				},
				{
					"filename": "loading05",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 427,
						"h": 383
					},
					"frame": {
						"x": 456,
						"y": 1926,
						"w": 427,
						"h": 383
					}
				},
				{
					"filename": "loading09",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 427,
						"h": 383
					},
					"frame": {
						"x": 456,
						"y": 2311,
						"w": 427,
						"h": 383
					}
				},
				{
					"filename": "loading00",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 401,
						"h": 383
					},
					"frame": {
						"x": 481,
						"y": 1,
						"w": 401,
						"h": 383
					}
				},
				{
					"filename": "loading04",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 401,
						"h": 383
					},
					"frame": {
						"x": 481,
						"y": 386,
						"w": 401,
						"h": 383
					}
				},
				{
					"filename": "loading08",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 401,
						"h": 383
					},
					"frame": {
						"x": 481,
						"y": 771,
						"w": 401,
						"h": 383
					}
				},
				{
					"filename": "loading12",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 700,
						"h": 601
					},
					"spriteSourceSize": {
						"x": 137,
						"y": 71,
						"w": 401,
						"h": 383
					},
					"frame": {
						"x": 481,
						"y": 1156,
						"w": 401,
						"h": 383
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:2199914d82daf7814d590bddae95b7bd:463e609c5f44c311857c11c11fbefbdb:f1ac1ff584e6001b1e1e1b0f6cf7d88d$"
	}
}
